import styles from './EmptyState.module.css';

export default function EmptyState({ icon, message, ctaLabel, onCtaClick }) {
  return (
    <div className={styles.wrapper}>
      {icon && <div className={styles.icon}>{icon}</div>}
      <p className={styles.message}>{message}</p>
      {ctaLabel && onCtaClick && (
        <button className={styles.cta} onClick={onCtaClick}>{ctaLabel}</button>
      )}
    </div>
  );
}
